import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  InstallsMessage,
  MessageData,
  Messages,
} from 'src/app/model/messages/messages.model';
import {
  APIUrls,
  WebConfigurationService,
} from '../http/common/web-configuration.service';

@Injectable({
  providedIn: 'root',
})
export class MessagesService extends WebConfigurationService {
  constructor(protected http: HttpClient) {
    super(http);
  }

  /**
   * Get messages list
   * @returns an Observable
   */
  public getMessagesList(): Observable<Messages> {
    return this.authGetObs<Messages>(APIUrls.getMessagesUrl());
  }

  /**
   * Get message datas with its id
   * @returns an Observable
   */
  public getMessage(id: string): Observable<MessageData> {
    return this.authGetObs<MessageData>(this.getMessageUrl(id));
  }

  /**
   * post update about message
   */
  public postMessage(formData: FormData): Observable<any> {
    return this.http.post(APIUrls.postMessageUrl(), formData, {
      headers: this.createHeaders(),
    });
  }

  /**
   * Add install to a message with id_message and id_installation
   * @returns an Observable
   */
  public addInstall(message: string, installation: string): Observable<string> {
    console.log(APIUrls.addInstallMessageUrl() + message + '/' + installation);
    return this.authGetObs<string>(
      APIUrls.addInstallMessageUrl() + message + '/' + installation
    );
  }

  /**
   * Add install to a message with id_message and id_message_installation
   * if id_message_installation = 'all' remove all installations from message
   * @returns an Observable
   */
  public removeInstall(
    message: string,
    installation: string
  ): Observable<string> {
    return this.authGetObs<string>(
      APIUrls.removeInstallMessageUrl() + message + '/' + installation
    );
  }

  /**
   * Get installations list which can be added to message
   * @returns an Observable
   */
  public getInstalls(id: string): Observable<InstallsMessage> {
    return this.authGetObs<InstallsMessage>(
      APIUrls.getInstallsMessageUrl() + id
    );
  }

  /**
   * Get installations list which can be added to message
   * @returns an Observable
   */
  public deleteMessage(id: string): Observable<string> {
    return this.authGetObs<string>(APIUrls.deleteMessageUrl() + id);
  }
}
